var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/buildify/embedding.ts
import "@adornis/buildify/client/components/x-buildify-spacing-picker.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-icon";
import "@adornis/entity-picker/client/x-entity-picker.js";
import { BuildifyLitElement } from "@adornis/html-based-buildify/client/BuildifyLitElement.js";
import "@adornis/html-based-buildify/client/nodes/doc.js";
import "@adornis/popover/x-dropdown-selection";
import { html, nothing } from "lit";
import { customElement, state } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { switchMap } from "rxjs";
import { WikiEntry } from "../../db/WikiEntry.js";
var NodeEmbedding = class extends BuildifyLitElement {
  constructor() {
    super(...arguments);
    this._entry = new RXController(
      this,
      this._constructedData.observable.pipe(
        switchMap(async (d) => {
          if (!d?.entryID) {
            return null;
          }
          return WikiEntry.getByID(d.entryID)({
            content: 1,
            readPermission: 1
          });
        })
      )
    );
  }
  content({ mode }) {
    if (this._constructedData.value?.entryID === "" || this._constructedData.value?.entryID === null) {
      return html`
        <x-flex horizontal crossaxis-center space="sm" ${css({ padding: this.spacing.md })}>
          <x-icon> info </x-icon>
          <x-text> Keine Seite eingebunden. </x-text>
        </x-flex>
      `;
    }
    if (this._entry.isLoading) {
      return html`<x-loader></x-loader>`;
    }
    if (!this._entry.value) {
      return html`
        <x-flex horizontal crossaxis-center space="sm" ${css({ padding: this.spacing.md })}>
          <x-icon> warning </x-icon>
          <x-text> Seite nicht gefunden oder keine Berechtigung um diese zu sehen. </x-text>
        </x-flex>
      `;
    }
    return html`
      <node-doc mode="view">
        ${mode === "edit" && this._entry.value.readPermission ? html`
              <x-text bold ${css({ padding: "10px 0px", color: this.colors.accent })}>
                ${this._entry.value.readPermission}
              </x-text>
            ` : nothing}
        ${unsafeHTML(this._entry.value.content ?? "")}
      </node-doc>
    `;
  }
};
__decorateClass([
  state()
], NodeEmbedding.prototype, "_entry", 2);
NodeEmbedding = __decorateClass([
  customElement("node-embedding")
], NodeEmbedding);
export {
  NodeEmbedding
};
